var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isAuth)?_c('el-button',_vm._b({on:{"click":_vm.handleClick}},'el-button',_vm.$attrs,false),[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }